import React from "react";
import { StatusBadge } from "./styles";

type LawsuitStatusBadgeProps = {
  status?: string;
};

const LawsuitStatusBadge: React.FC<LawsuitStatusBadgeProps> = ({ status }) => {
  const isActive = status.toUpperCase() === "ACTIVE";

  return (
    <StatusBadge active={isActive}>
      <p>{isActive ? "Ativo" : "Encerrado"}</p>
    </StatusBadge>
  );
};

export default LawsuitStatusBadge;
